import { FC, ReactNode, useMemo } from 'react';
import { uiContainer } from '../CutCorners';
import { cn } from 'lib/utils';

interface BPContainerProps {
  children: ReactNode;
  twWidth?: string | null;
  gridClass?: boolean;
}

const BPContainer: FC<BPContainerProps> = ({
  children,
  twWidth,
  gridClass,
}) => {
  const cols = useMemo(
    () =>
      children ? `md:grid-cols-${children.toString().split(',').length}` : '',
    [children]
  );

  return (
    <div
      className={cn(
        'grid gap-[8px] items-center justify-center relative h-auto md:h-[72px] p-[10px] md:px-[8px] md:py-0 ',
        gridClass ? 'grid-rows-[72px_auto] md:grid-cols-[1fr_171px]' : cols,
        twWidth ?? 'w-auto md:w-[644px]'
      )}
    >
      <div
        className={cn(
          'block absolute w-full h-full backdrop-blur-md bg-white/[0.05]',
          uiContainer.bg
        )}
      />
      <div
        className={cn(
          'block absolute top-0 left-0 w-full h-full pointer-events-none bg-gradient-to-b from-white/30 to-white/10',
          uiContainer.border
        )}
      />
      {children}
    </div>
  );
};

export default BPContainer;
